import { render, staticRenderFns } from "./modal-language-selector.vue?vue&type=template&id=c289029e&scoped=true"
import script from "./modal-language-selector.vue?vue&type=script&lang=ts"
export * from "./modal-language-selector.vue?vue&type=script&lang=ts"
import style0 from "./modal-language-selector.vue?vue&type=style&index=0&id=c289029e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c289029e",
  null
  
)

export default component.exports